<template>
  <img
    :src="require('./330px-Flag_of_South_Africa.svg.png')"
    width="24"
    height="16"
    style="object-fit: cover; border-radius: 2px;"
    alt="South Africa"
  />
</template>

<script>
export default {
  name: 'SouthAfricaFlag',
}
</script>
